import client from "./internal/httpClient";

const bannerApi = {
    BannerType: {}
}

bannerApi.BannerType.HOME_PAGE = 1
bannerApi.BannerType.ABOUT_US = 2

bannerApi.list = function (data) {
    return client.post("/door-client/banner/list.php",data)
}

export default bannerApi;